import * as Yup from 'yup';

export const ChangePasswordValidationSchema = Yup.object().shape({
  current_password: Yup.string().required('Current password is required'),
  new_password: Yup.string().required('New password is required'),
  confirm_password: Yup.string()
    .required('Please confirm your new password')
    .oneOf([Yup.ref('new_password')], 'Passwords do not match'),
});

export const ResetPasswordValidationSchema = Yup.object().shape({
  new_password: Yup.string().required('New password is required'),
  confirm_password: Yup.string()
    .required('Please confirm your new password')
    .oneOf([Yup.ref('new_password')], 'Passwords do not match'),
});
